import {Component, Input, Output, EventEmitter, ViewChild, OnInit, SimpleChanges, OnChanges} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../services/auth.service";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'micro-contactCompany-select',
  templateUrl: './contactCompany-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi:true,
      useExisting: ContactCompanySelectComponent
    }
  ]
})

export class ContactCompanySelectComponent implements OnInit, OnChanges, ControlValueAccessor {

  @ViewChild("sel", {static: true}) sel:MicroSelectComponent;

  @Input()
  mode:string = 'simple';

  @Output()
  contactCompanyIdChange:EventEmitter<any> = new EventEmitter<any>();

  @Output()
  contactCompanyChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  contactCompanyId:any;

  @Input()
  companyId:any = '';

  @Output()
  valueChange:EventEmitter<any> = new EventEmitter<any>();

  @Input()
  value:any = '';

  @Input()
  required:boolean = false;

  @Input()
  disabled:boolean = false;

  @Input()
  jump:boolean=true;

  @Input()
  placeholder:string = 'Contact Company';

  options:any[];

  onChange = (contactCompanyId) => {};
  onTouched = () => {};
  touched = false;

  change(e) {
    this.onChange(e);
    this.contactCompanyIdChange.emit(this.contactCompanyId);
    this.valueChange.emit(this.sel.getSelectedValue());
    this.contactCompanyChange.emit(this.options.find(c => c.id === e));
  }

  reloadDebouncer:EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth:AuthService, private env:EnvService, private http:HttpClient) {
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(contactCompanyId: string): void {
    this.contactCompanyId = contactCompanyId;
  }

  reload() {
    this.sel.loading = true;
    let params:HttpParams = new HttpParams();
    if (this.companyId && this.companyId.trim() !== "") {
      params = params.set('companyId', this.companyId);
    }
    return this.http.get(`${this.env.e.url}/auth/contactCompanies/all`, {params:params})
      .subscribe(data => {
        this.options = data as any[];
        this.sel.loading = false;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'companyId') {
        this.reloadDebounced();
      }
    }
  }
  ngOnInit(): void {
    if (this.auth.isCompanyAdmin()) {
      this.companyId = this.auth.companyIdFilter;
    } else {
      this.companyId = this.auth.getCompanyId();
    }
    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => {
      this.reload();
    });
    this.reloadDebounced();
  }

  reloadDebounced() {
    this.reloadDebouncer.emit();
  }

}
